import { CodedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCachedAdminApi } from "../../api/admin-api/useCachedAdminApi";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useLanguages = (): SprintQueryResult<CodedProperty[]> => {
    const { getLanguagesLookup } = useCachedAdminApi();

    return useSprintQuery<CodedProperty[]>({
        queryKey: [DataHooksQueryKey.Languages],
        queryFn: async (): Promise<CodedProperty[]> => {
            const response = await getLanguagesLookup();
            return response.items;
        }
    });
};
